import { useEffect, useState } from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import './LoginScreen.css';

export default function LoginScreen() {
  const [stylesReady, setStylesReady] = useState(false);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${process.env.PUBLIC_URL}/amplify-ui.css`;
    link.onload = () => setStylesReady(true);
    link.onerror = () => setStylesReady(true); // still show the form if it fails
    document.head.appendChild(link);
    return () => link.remove(); // removed as soon as the user is signed in
  }, []);

  return (
    <div className="auth-wrapper" style={{ visibility: stylesReady ? 'visible' : 'hidden' }}>
      <Authenticator hideSignUp={true} />
    </div>
  );
}